"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _NotificationConfiguration_1 = require("./_NotificationConfiguration");
exports.PutBucketNotificationConfigurationInput = {
    type: "structure",
    required: ["Bucket", "NotificationConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        NotificationConfiguration: {
            shape: _NotificationConfiguration_1._NotificationConfiguration,
            locationName: "NotificationConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "NotificationConfiguration"
};
//# sourceMappingURL=PutBucketNotificationConfigurationInput.js.map